module.exports = __webpack_public_path__ + "img/sd_banner_text.90ea392c.png";